import { ErrorTag } from "@/components/ErrorTag/ErrorTag";
import { useTrans } from "@/translations";

import React from "react";

import { twMerge } from "tailwind-merge";

export type Tab = {
  key?: string;
  title: string;
  nrErrors?: number;
};

type Props = {
  tabs: Tab[];
  activeTab: number;
  setActiveTab: (index: number) => void;
};

export const Tabs: React.FC<Props> = ({ tabs, activeTab, setActiveTab }) => {
  const { t } = useTrans();

  const activeTabClass =
    "border-b-4 border-saturated-lime font-medium border-solid";
  const inactiveTabClass =
    "cursor-pointer font-normal hover:border-b-4 hover:border-grey3 hover:bg-grey1 hover:border-solid";

  return (
    <div className="flex overflow-x-scroll text-sm">
      {tabs.map(({ title, nrErrors }, index) => (
        <div
          key={title}
          className={twMerge(
            "flex border-b-4 border-transparent px-6 py-4 text-nowrap lg:text-wrap",
            index === activeTab ? activeTabClass : inactiveTabClass,
          )}
          onClick={() => setActiveTab(index)}
        >
          {t(title)}
          {nrErrors! > 0 && (
            <div className="ml-3">
              <ErrorTag nrErrors={nrErrors!} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
